import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs';
import { AppModeService } from 'src/app/services/app-mode.service';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-create-password',
  templateUrl: './create-password.component.html',
  styleUrls: ['./create-password.component.css'],
})
export class CreatePasswordComponent implements OnInit {
  isMobileApp = false;
  newPasswordValue = '';
  confirmPasswordValue = '';
  showNewPassword = false;
  showConfirmPassword = false;
  newPasswordError = '';
  confirmPasswordError = '';
  requestError = '';
  successMessage = '';
  isLoading = false;
  private email = '';

  constructor(
    private readonly appModeService: AppModeService,
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.isMobileApp = this.appModeService.isApp();

    this.email = this.router.getCurrentNavigation()?.extras.state?.['email'] || '';
    if (!this.email) {
      this.email = sessionStorage.getItem('pwResetEmail') ?? '';
    }

    if (!this.email) {
      this.navigateBack();
    }
  }

  toggleNewPassword(): void {
    this.showNewPassword = !this.showNewPassword;
  }

  toggleConfirmPassword(): void {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  validateAndSubmit(): void {
    this.newPasswordError = '';
    this.confirmPasswordError = '';
    this.requestError = '';
    this.successMessage = '';

    const password = this.newPasswordValue;
    const hasMinLength = password.length >= 8;
    const hasComplexity = /[A-Z]/.test(password) && /[a-z]/.test(password) && /\d/.test(password);

    if (!hasMinLength) {
      this.newPasswordError = 'CREATE_PASSWORD.ERROR_PASSWORD_TOO_SHORT';
      return;
    }

    if (!hasComplexity) {
      this.newPasswordError = 'CREATE_PASSWORD.ERROR_PASSWORD_COMPLEXITY';
      return;
    }

    if (this.confirmPasswordValue !== password) {
      this.confirmPasswordError = 'CREATE_PASSWORD.ERROR_PASSWORDS_DO_NOT_MATCH';
      return;
    }

    this.isLoading = true;
    this.authService
      .resetPassword(this.email, password)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: () => {
          sessionStorage.removeItem('pwResetEmail');
          this.successMessage = 'CREATE_PASSWORD.SUCCESS_RESET';
          const lang = this.route.snapshot.paramMap.get('lang') || 'en';
          setTimeout(() => {
            this.router.navigate([lang, 'login']);
          }, 1500);
        },
        error: () => {
          this.requestError = 'CREATE_PASSWORD.ERROR_RESET_FAILED';
        },
      });
  }

  navigateBack(): void {
    const lang = this.route.snapshot.paramMap.get('lang') || 'en';
    this.router.navigate([lang, 'forgot-password']);
  }
}
